/**
 * Route in-page anchor links through Lenis so the jump is smoothed and lands
 * clear of the fixed 80px header. Falls back to native scrolling (which honours
 * the CSS scroll-margin-top) when smooth scroll is off.
 *
 * @param {import('lenis').default|null} [lenis] smooth-scroll instance
 */
export function initAnchorLinks(lenis) {
  document.querySelectorAll('a[href^="#"]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const hash = link.getAttribute('href')
      if (!hash || hash === '#') return
      const target = document.querySelector(hash)
      if (!target) return
      event.preventDefault()
      if (lenis) lenis.scrollTo(target, { offset: -80 })
      else target.scrollIntoView()
    })
  })
}
